var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',[_c('template',{slot:"content"},[_c('help-content',{attrs:{"title":'参加中のイベントを退出したい'}},[_c('template',{slot:"content"},[_c('div',{staticClass:"text"},[_vm._v("\n          イベントは主催者ごとのグループに開催されています。イベントの退出はグループ管理者にお問い合わせください。"),_c('br'),_c('br'),_vm._v("\n          スライドメニューのMYグループからグループを退会すれば、そのグループが開催しているすべてのイベントから退出することができます。\n        ")])])],2)],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4cae27ca","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Help37.vue
// module id = otd3
// module chunks = 0